import * as React from "react";

import "./layout-mobile-header.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {UseState}       from "@Common/react/use-state";
import {isNotEmpty}     from "@Common/utils/collections";

import {MenuInternalLink}        from "../../common/components/internal-link";
import {PRODUCTS_MENU_ITEM_NAME} from "../common/constants";

import {rLmdDefault}    from "./side-menu/left-menu-dropdown-default";
import {lmdProducts}    from "./side-menu/left-menu-dropdown-products";
import {rLeftMenuItem}  from "./side-menu/left-menu-item";
import {MobileSideMenu} from "./side-menu/side-menu";

export const LayoutMobileHeader = ({next}) => cs(
    consumeContext("themeScheme"),
    consumeContext("routerHistory"),
    consumeContext("menus"),
    ["mobileSideMenu", ({themeScheme, menus}, next) => (
        MobileSideMenu({
            renderContent: ({navBlock}) => cs(
                ["expand", (_, next) => UseState({next})],
                ({expand}) => (
                    <div className="">
                        {[
                            menus && {...menus.profileMenu, linkLabel: "MY ACCOUNT"},
                            ...menus?.leftMenus||[],
                            (menus || themeScheme?.helpMenu) && (
                                {...menus?.helpMenu || themeScheme.helpMenu, linkLabel: "HELP"}
                            ),
                        ]
                            .filter(v=>v)
                            .map((menu, i) => cs(
                                keyed(i),
                                () => rLeftMenuItem({
                                    label: menu.linkLabel?.toUpperCase(),
                                    link: menu.link,
                                    type: menu.type,
                                    expanded: expand.value === i,
                                    onChangeExpanded: (expanded) => expand.onChange(expanded ? i : null),
                                    navBlock,
                                    rDropdown: menu.name === PRODUCTS_MENU_ITEM_NAME ? (
                                        () => lmdProducts({navBlock})
                                    ) : (
                                        isNotEmpty(menu.subMenu) && (() => rLmdDefault({items: menu.subMenu, navBlock}))
                                    ),
                                })
                            ))
                        }
                    </div>
                )
            ),
            next,
        })
    )],
    ({menus, mobileSideMenu, themeScheme, routerHistory}) => next({
        render: ({navBlock=undefined}) => (
            <div className="layout-mobile-header-8fd">
                {themeScheme.xpresso.headerBanner && (
                    <div className="banner" style={{background: themeScheme.xpresso.headerColor}}>
                        <div className="restrict-width-1">
                            {MenuInternalLink({
                                className: "logo-ov1",
                                to: "/",
                                "xd-qa-type": "logo",
                                "xd-qa-name": "company",
                                navBlock,
                                children: (
                                    <img alt={themeScheme?.companyName + " Logo"} src={themeScheme.xpresso.headerLogo}/>
                                ),
                            })}
                            <img alt={themeScheme?.companyName + " Banner"} className="banner-ov1" src={themeScheme.xpresso.headerBanner}/>
                        </div>
                    </div>
                )}
                <div
                    className="main"
                    style={{
                        background: themeScheme.xpresso.menuBackgroundColor,
                    }}
                >
                    <div className="restrict-width-1">
                        {!themeScheme.xpresso.headerBanner && (
                            MenuInternalLink({
                                to: `/`,
                                className: "logo-2ie",
                                "xd-qa-type": "image",
                                "xd-qa-name": "company logo",
                                children: (
                                    <img alt={themeScheme?.companyName + " Logo"} src={themeScheme.xpresso.headerLogo}/>
                                ),
                            })
                        )}

                        {menus ? (
                            <i
                                className="fa fa-bars"
                                onClick={() => mobileSideMenu.show({navBlock})}
                                style={{color: themeScheme.xpresso.menuTextColor}}
                            />
                        ) : (
                            <i
                                className="fa fa-question-circle-o"
                                xd-qa-type="icon"
                                xd-qa-name="help"
                                style={{color: themeScheme.xpresso.menuTextColor}}
                                onClick={(e) => {
                                    routerHistory.push("/support/")
                                }}
                            />
                        )}

                        {/*{rNav({})}*/}
                    </div>
                </div>
            </div>
        ),
    })
);
